
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CommonUtilityService } from './common-utility-service';
import { AuthenticationService } from '../services/authentication.service';
@Injectable()

export class AuthGuard implements CanActivate {

    constructor(
        private utilityService: CommonUtilityService,
        private router: Router,
        private authenticationService: AuthenticationService
    ) { }

    // canActivate(activatedRoute: ActivatedRouteSnapshot) {
    //     if (this.utilityService.getCookie('isLoggedIn')) {
    //         return true;
    //     }
    //     this.router.navigate(['/dashboard']);
    // }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let data = route.data;
        let allowedRoles = data?.allowedRoles
        const currentUser = this.utilityService.getCookie('isLoggedIn');
        if(allowedRoles && allowedRoles.indexOf(this.authenticationService.getRole()) < 0){
            if(currentUser){
            console.log("401 User not authorised");
            this.router.navigate(['/not-authorised']);
            }else{
                this.router.navigate(['/login']); 
            }
            return false;
        }
        if (currentUser) {
            // logged in so return true
            return true;
        }
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login']);
        return false;
    }
}
